// export const primaryColor = "#FFFFFF";
// export const primaryColor = "#1F393B";
// export const primaryColor = "#6260EF";
export const primaryColor = localStorage.getItem("primaryColor") && localStorage.getItem("primaryColor") !== undefined &&  localStorage.getItem("primaryColor")

